import React from 'react'
import Layer from './Layer'

const TransitLayer = ({}) => <Layer type="transit" />

TransitLayer.displayName = 'TransitLayer'

export default TransitLayer
